



















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { MomentOffered, filterTypes } from '@/MomentOffered'
import * as utils from '@/utils';
import * as utils_time from '@/utils_time';
import * as utils_topshot from '@/utils_topshot';
import { Plotly } from '@rleys/vue-plotly-basic'

@Component({
  name: 'MomentOfferedListComponent',
  components: { Plotly }
})
export default class MomentOfferedListComponent extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop({ default: null })
  public moment: MomentOffered

  @Prop({ default: 0 })
  public index: number                 // in case it's ever useful for us to know where we are in the main list

  @Prop({ default: filterTypes.Received })
  public filterUsed: filterTypes

  @Prop({ default: false })
  public isSignedInUser: boolean

  // public reactive member variables available to the html template
  public SHOW_IMAGE = true

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public getNicePriceString(number): string { return utils_topshot.getNicePriceString(number)}
  public getNicePossibleDecimalPriceString(number): string { return utils_topshot.getNicePossibleDecimalPriceString(number)}

  public clickToTopShot() {
    const url: string = this.moment.getTopShotLink(this.filterUsed === filterTypes.Received || !this.moment.isEditionOffer)
    if (url) window.open(url, "_blank"); 
  }

  public getActionButtonName(): string {
    if (this.filterUsed === filterTypes.Received) return "Accept"
    if (this.filterUsed === filterTypes.Made) return "Cancel"
  }

  public getActionVariant(): string {
    if (this.filterUsed === filterTypes.Received) return "primary"
    if (this.filterUsed === filterTypes.Made) return "secondary"
  }

  public onAction() {
    let url: string = 'https://accounts.meetdapper.com/offers'    // old
    // if (this.filterUsed === filterTypes.Received) url = "https://nbatopshot.com/my-offers/received"
    if (this.filterUsed === filterTypes.Received) url = this.moment.getTopShotLink(true)
    if (this.filterUsed === filterTypes.Made) url = "https://nbatopshot.com/my-offers/submitted"

    if (url) window.open(url, "_blank"); 
  }

  public showAnyForSerial(): boolean {
    if (this.filterUsed === filterTypes.Made && this.moment.isEditionOffer) return true
    return false
  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)
  }

  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }

}
